import React from 'react';
import ScanPlateContainer from './ScanPlateContainer';
import { useLocation } from 'react-router-dom';
import TrackerNoAccess from '../NoAccess/TrackerNoAccess';
import { withMobileAppMode } from '@front-activerse/common-components';

const ScanPlatePage: React.FC<{ mobileAppMode: boolean; fromUserMeals?: boolean }> = ({
  mobileAppMode,
  fromUserMeals,
}) => {
  const location = useLocation();

  const aiAccess = sessionStorage.getItem('aiAccess');

  if (aiAccess === 'true' || mobileAppMode) {
    return <ScanPlateContainer key={location.key} fromUserMeals={fromUserMeals} />;
  }

  return <TrackerNoAccess />;
};

export default withMobileAppMode(ScanPlatePage);
